export const ACQUISITION_CONTEXTS_KEY = 'joy_acquisition_contexts';
export const MAX_ACQUISITION_CONTEXTS = 10;
